exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".hyperlink-text {\n  color: #3A5CE9;\n  display: flex;\n  white-space: initial;\n  cursor: pointer;\n}\n\n", ""]);

// exports
